<div class="cliente">
  <div class="container-header">
    <h4 class="mb-0">Cadastro de Clientes</h4>

    <div class="container-header-block container-header-btns">
      <button type="button" class="btn btn-primary mr-2" (click)="insert()">
        <i class="fas fa-plus" aria-hidden="true"></i> Novo
      </button>

      <!-- Opções -->
      <div class="btn-group" *ngIf="options?.hasAnyOption()">
        <button
          type="button"
          class="btn btn-light dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="d-none d-sm-inline-block">Opções</span>
        </button>
        <div class="dropdown-menu">
          <a
            class="dropdown-item"
            *ngIf="options?.canImprimirListagem"
            (click)="openListagemReportModal()"
          >
            <i class="fas fa-print" aria-hidden="true"></i> Imprimir Listagem
          </a>

          <div class="dropdown-divider"></div>

          <div class="dropdown-divider"></div>

          <!-- Import ERP V1 -->
          <a
            class="dropdown-item"
            *ngIf="options?.canImportErp_v1"
            (click)="openIntegracaoErpImportModal_v1()"
          >
            <i class="fas fa-download"></i> Importar do ERP
          </a>

          <a
            class="dropdown-item"
            *ngIf="options?.canImportErp"
            (click)="openIntegracaoErpImportModal()"
          >
            <i class="fas fa-download"></i> Importar do ERP
          </a>

          <!-- Excel -->
          <div class="dropdown-divider"></div>
          <h6 class="dropdown-header">Excel</h6>
          <a class="dropdown-item" (click)="openExcelExportContatoModal()">
            <i class="far fa-file-excel"></i> Exportar Contatos
          </a>

          <!--
                    <h6 class="dropdown-header" *ngIf="options?.hasImportarOptions()">Importações</h6>
                    <a class="dropdown-item" *ngIf="options?.canImportar" (click)="openImportModal()">
                        <i class="fas fa-upload" aria-hidden="true"></i> Importar
                    </a>
                     <a class="dropdown-item" *ngIf="options?.canImportarUnidadeNegocio" (click)="openImportUnidadeNegocioModal()">
                        <i class="fas fa-upload" aria-hidden="true"></i> Importar Unidades de Negócio
                    </a>
                    <div class="dropdown-divider" *ngIf="options?.hasImportarOptions()"></div>
                    -->
        </div>
      </div>
    </div>
  </div>

  <div class="container-filter">
    <!-- <sgt-cliente-filter
      #clienteFilter
      [filter]="filter"
      (filterInitialized)="onFilterInitialized()"
      (filterChange)="onFilterChange()"
      (filterCleaned)="onFilterCleaned()"
    >
    </sgt-cliente-filter> -->

    <sgt-novo-cliente-filter
      (filterInitialized)="onFilterInitialized($event)"
      (filterChange)="onFilterChange($event)">
    </sgt-novo-cliente-filter>

  </div>

  <div class="container-header-block container-header-visualizacao">
    <sgt-novo-tabs
      [tabs]="visualizacaoTabs"
      [activeTab]="activeVisualizacaoTab"
      (activeTabChange)="onVisualizacaoTabChange($event)"
    >
      <div class="container-content" #containerContent>
        <!-- List -->
        <ng-template [ngIf]="isVisualizacaoModoList()">
          <!-- <sgt-cliente-list
            #list
            [filter]="filter"
            (orderByChanged)="orderBy = $event"
            (orderByDirChanged)="orderByDir = $event"
          >
          </sgt-cliente-list> -->
          <sgt-novo-cliente-list
            #novoList
            [filter]="filter">
          </sgt-novo-cliente-list>
        </ng-template>

        <!-- Dashboad -->
        <ng-template [ngIf]="isVisualizacaoModoDashboard()">
          <sgt-cliente-dashboard #dashboard [filter]="filter">
          </sgt-cliente-dashboard>
        </ng-template>
      </div>
    </sgt-novo-tabs>
  </div>
</div>

<!-- Modal para importar os clientes -->
<sgt-cliente-import-modal
  idModal="clienteImportModal"
  (afterImport)="onAfterImport()"
  #clienteImportModal
>
</sgt-cliente-import-modal>

<!-- Moda para importar as unidades de negócio dos clientes -->
<sgt-cliente-unidade-negocio-import-modal
  #clienteUnidadeNegocioImportModal
  (afterImport)="onAfterImportUnidadeNegocio()"
>
</sgt-cliente-unidade-negocio-import-modal>

<!-- Impressão da Listagem de Clientes -->
<sgt-cliente-listagem-report-modal #listagemReportModal>
</sgt-cliente-listagem-report-modal>

<!-- Modal para importar clientes do ERP V1 -->
<sgt-integration-cliente-modal
  #integrationModal
  (afterExecuteIntegration)="afterImporErp_v1()"
>
</sgt-integration-cliente-modal>

<!-- Modal para importar clientes do ERP -->
<sgt-cliente-integracao-erp-import-modal #integracaoErpImportModal>
</sgt-cliente-integracao-erp-import-modal>

<!-- Modal exportação contatos dos clientes -->
<sgt-cliente-contato-excel-export-modal #excelExportContatoModal>
</sgt-cliente-contato-excel-export-modal>
